import axios from 'axios';
import axiosBasicInstance from './../axiosConfig';

export const loginNormal = async (username, password, rememberMe) => {
   try {
      const response = await axiosBasicInstance.post('/login', {
         username: username,
         password: password,
         rememberMe: rememberMe,
      });
      return response;
   } catch (error) {
      throw error;
   }
};

export const loginSSO = async (token, method) => {
   try {
      const response = await axiosBasicInstance.post('/login/sso', {
         token: token,
         method: method,
      });
      return response;
   } catch (error) {
      throw error;
   }
};

export const logoutRequest = async () => {
   try {
      const response = await axiosBasicInstance.get('/logout');
      return response;
   } catch (error) {
      throw error;
   }
};

export const getConfigsLogin = async () => {
   try {
      const response = await axiosBasicInstance.get('/configs-login');
      return response;
   } catch (error) {
      throw error;
   }
};

export const getSsoUserInfo = async (accessToken, authority) => {
   try {
      const response = await axios.get(
         `${authority}/protocol/openid-connect/userinfo`,
         {
            headers: {
               Authorization: `Bearer ${accessToken}`,
               Accept: 'application/json',
            },
            withCredentials: false,
         }
      );
      return response;
   } catch (error) {
      throw error;
   }
};

export const refreshToken = async () => {
   try {
      const response = await axiosBasicInstance.post(`/refreshToken`);
      return response;
   } catch (error) {
      throw error;
   }
};
